// JS que hace scroll en pantalla hacia un elemento HTML a otro. Ej. Boton leer mas de descripcion vista PRODUCTO

$(document).ready(function(){
    // variables

    // acciones
    $('body').on('click', '.js-link-scroll__action', function(event) {
        linkScroll($(this))
    })

    // funciones
    function linkScroll(action) {
        $('.js-link-scroll__content').each( function (){
            if ( action.data('link-scroll__id') == $(this).data('link-scroll__id') ) {
                window.scrollTo({ top: $(this).offset().top, behavior: 'smooth' })
            }
        })
    }
    
})